import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=486112b9&scoped=true"
import script from "./AddClass.vue?vue&type=script&lang=js"
export * from "./AddClass.vue?vue&type=script&lang=js"
import style0 from "./AddClass.vue?vue&type=style&index=0&id=486112b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486112b9",
  null
  
)

export default component.exports